<span class="icon-badge" [class]="badgeClass$()">
  <fa-icon class="icon-badge__icon" [icon]="icon$()"></fa-icon>
</span>
